import translates from './zhm.json';
import restNotifications from './notifiers.json';

export default {
  zhm: { ...translates, ...restNotifications },
};
